<div [ngClass]="colorClass">
  {{ value }}
</div>